import React, { Component } from 'react';

import ResourceCategoriesAccordion from 'containers/ResourceCategoriesAccordion';
import AccordionItem from 'components/Accordion/AccordionItem';

class ForumCategories extends Component {

  renderTopic(topic, countInfo) {
    return (
      <AccordionItem
        isForForum
        key={topic.id}
        title={topic.title}
        countInfo={countInfo(topic)}
        url={`/forum?topic=${topic.id}&title=${topic.title}`}
      />
    );
  }

  render() {
    return (
      <div className="wrapper-full is-collapsed is-collapsed-top has-background" ref="wrapper">
        <div className="wrapper-small is-padded-top">
          <h1>{__('members.forum.titles.categories')}</h1>
          <ResourceCategoriesAccordion
            isForForum
            resourceType="forumThreads"
            resourceNameSingular={__('entities.threads.singular')}
            resourceNamePlural={__('entities.threads.plural')}
            renderTopic={this.renderTopic}
            scrollElementGetter={() => this.refs.wrapper.parentElement}
          />
        </div>
      </div>
    );
  }
}

export default ForumCategories;



/** WEBPACK FOOTER **
 ** ./src/members/Main/Forum/ForumCategories/index.js
 **/